import type { ThemeConfig } from 'antd';

export const backofficeTheme: ThemeConfig = {
  token: {
    colorPrimary: '#087f79',
    colorInfo: '#087f79',
    colorPrimaryBg: '#e8f4f1',
    colorPrimaryBgHover: '#d5ebe5',
    colorInfoBg: '#edf7f5',
    colorInfoBorder: '#c9e4df',
    colorSuccess: '#21865d',
    colorSuccessBg: '#eff8f1',
    colorSuccessBorder: '#cce5d2',
    colorWarning: '#ad7415',
    colorWarningBg: '#fff8e8',
    colorWarningBorder: '#eddfbc',
    colorError: '#cf4545',
    colorErrorBg: '#fff2f0',
    colorErrorBorder: '#f2d0cd',
    colorText: '#203638',
    colorTextSecondary: '#667774',
    colorBgLayout: '#f2f1ec',
    colorBgContainer: '#ffffff',
    colorBorderSecondary: '#e5e7e1',
    borderRadius: 8,
    borderRadiusLG: 12,
    fontSize: 14,
    controlHeight: 36,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    Card: { paddingLG: 24, headerFontSize: 17 },
    Table: { headerBg: '#f7f8f5', rowHoverBg: '#f0f7f4', cellPaddingBlock: 12, cellPaddingInline: 12 },
    Statistic: { contentFontSize: 36 },
    Button: { primaryShadow: 'none' },
    Layout: { bodyBg: '#f2f1ec', headerBg: '#ffffff' },
  },
};
